export const VALID_TX_ID =
  '4b6ee974f1dd179071d027562e1fd1c83965efa4a171ec84f00b6c638e36fa4e'
export const TX_FEE = 4374
export const INVALID_TX_ID = '0x00000000000000000000000000000000000000'
